/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable prefer-template */
import React, { Component } from 'react';
import {
  Image,
  Grid,
  Dropdown,
  Divider,
  Loader,
  Message,
  Icon
} from 'semantic-ui-react';
import _ from 'lodash';
import moment from 'moment';
import { getIframe } from '../../services/InsightsPreviewManager';
import Images from '../../assets/Images';
import { getDashboards } from '../../services/DashboardService';

import IframePasswordModal from './IframePasswordModal';
import './InsightsPreviewDetails.css';

class InsightsPreviewDetails extends Component {
  state = {
    accounts: [],
    oem: '',
    supportedDashboards: '',
    dashboards: null,
    dashboardOptions: [],
    selectedDashboard: '',
    iframe: '',
    date: '',
    expiredAt: '',
    linkExpired: false,
    accountNames: '',
    showFilterTooltip: false,
    loadingDashboards: false,
    loadingIframe: false,
    errorMessage: '',
    showPasswordModal: false,
    password: ''
  };

  componentDidMount() {
    this.initialize();
  }

  initialize = () => {
    this.setState({ ...this.state, loadingDashboards: true }, async () => {
      const getDashboardsResult = await getDashboards();
      const { dashboards = [] } = getDashboardsResult;
      const dashboardOptions = _.map(dashboards, (op, index) => ({
        key: index,
        value: op.dashboard_id,
        text: op.name
      }));

      this.setState(
        {
          ...this.state,
          dashboards,
          dashboardOptions,
          loadingDashboards: false
        },
        () => {
          this.getIframe('', true);
        }
      );
    });
  };

  getIframe = (password = '', calledOnMount = false) => {
    const uniqueId = this.props.match.params.url;
    this.setState(
      { ...this.state, loadingIframe: true, password },
      async () => {
        const { dashboardOptions } = this.state;
        let newStateParameters = {};
        const customHeaders = {
          Authorization: password
        };
        const getIframeResult = await getIframe(uniqueId, customHeaders);
        const { statusCode } = getIframeResult;
        if (statusCode === 200) {
          const {
            dashboards,
            accountNames,
            market,
            expiredAt,
            iframe,
            date,
            oem,
            campaign,
            funding
          } = getIframeResult;
          let selectedDashboard;
          const supportedDashboards = dashboards;

          if (dashboards && dashboards.split(',').length > 1) {
            selectedDashboard = parseInt(dashboards.split(',')[0], 10);
            const supportedOptions = dashboardOptions.filter((option) =>
              dashboards
                .split(',')
                .find((item) => parseInt(item, 10) === option.value)
            );
            this.setState((prevState) => ({
              ...prevState,
              dashboardOptions: supportedOptions
            }));
          } else if (dashboards) {
            selectedDashboard = dashboards;
          }

          this.setState((prevState) => ({ ...prevState, selectedDashboard }));

          const accounts = accountNames.split(',');
          const markets = market ? market.split(',') : [];
          const linkExpired = new Date() > new Date(expiredAt);
          newStateParameters = {
            iframe,
            date,
            accounts,
            oem,
            market: markets,
            campaign,
            funding,
            expiredAt,
            linkExpired,
            supportedDashboards,
            accountNames,
            loadingIframe: false,
            showPasswordModal: false
          };
        } else {
          const { error } = getIframeResult;
          newStateParameters = {
            errorMessage: error,
            loadingIframe: false,
            showPasswordModal: statusCode === 403 && calledOnMount
          };
        }

        this.setState((prevState) => ({
          ...prevState,
          ...newStateParameters
        }));
      }
    );
  };

  onDashboardSelect = async (event, { options, value }) => {
    const { password } = this.state;

    const dashboard = _.find(options, (option) => {
      return option.value === value;
    });

    const uniqueId = this.props.match.params.url;

    const customHeaders = {
      Authorization: password
    };

    const result = await getIframe(
      uniqueId + '%7C' + dashboard.value,
      customHeaders
    );
    const { statusCode, iframe: iframeResult } = result;
    const iframe = statusCode === 200 ? iframeResult : '';

    this.setState({
      ...this.state,
      iframe,
      selectedDashboard: dashboard.value
    });
  };

  getDashboardName = () => {
    const dashboard = this.state.dashboardOptions.find(
      (item) => item.value === parseInt(this.state.supportedDashboards, 10)
    );
    return dashboard.text;
  };

  toggleFilterTooltip = () => {
    const { showFilterTooltip } = this.state;
    if (showFilterTooltip) {
      this.setState({ showFilterTooltip: false });
    } else {
      this.setState({ showFilterTooltip: true });
    }
  };

  togglePasswordModal = () => {
    const { showPasswordModal } = this.state;
    this.setState({ ...this.state, showPasswordModal: !showPasswordModal });
  };

  render() {
    const {
      accounts,
      oem,
      market,
      campaign,
      funding,
      linkExpired,
      date,
      iframe,
      expiredAt,
      supportedDashboards,
      selectedDashboard,
      dashboardOptions,
      showFilterTooltip,
      loadingDashboards,
      loadingIframe,
      errorMessage,
      showPasswordModal
    } = this.state;

    return (
      <div
        onMouseDown={
          showFilterTooltip
            ? this.toggleFilterTooltip
            : () => {
                return null;
              }
        }
        className="insights-detail-container"
      >
        {loadingDashboards && <Loader active content="Loading Dashboards" />}
        {loadingIframe && <Loader active content="Loading Looker Iframe" />}

        {linkExpired && (
          <div>
            <div className="div-link-expired">
              <p>
                <b>LINK EXPIRED</b>
              </p>
              <p>This link has expired and the iframe is no longer viewable.</p>
              <p>
                Please contact your account manager to receive an updated link.
              </p>
            </div>
          </div>
        )}

        {!linkExpired && iframe && (
          <div className="insights-detail-iframe-container">
            <div className="insights-detail-header">
              <Image
                src={Images.alexiaLogoWhite}
                className="insights-detail-logo"
                alt="logo"
                verticalAlign="middle"
              />
              <Image
                src={Images.patentPending}
                className="insights-detail-patent"
                alt="patentPending"
              />
            </div>
            <Divider hidden />
            <div>
              <Grid stackable width="equal">
                <Grid.Row stackable>
                  <Grid.Column width={2}>
                    <Grid container stackable>
                      <Grid.Column>
                        <div className="insights-header-column">
                          <h2 className="insights-header-title">
                            Insights Preview
                          </h2>
                          <span>
                            Link expires{' '}
                            {moment(expiredAt, 'YYYY-MM-DD').fromNow()}
                          </span>
                        </div>
                      </Grid.Column>
                    </Grid>
                  </Grid.Column>
                  <Grid.Column width={14}>
                    <Grid stackable container>
                      <Grid.Column width={2}>
                        <span className="insights-header-title">Dashboard</span>
                        <p>
                          {supportedDashboards &&
                          supportedDashboards.split(',').length > 1 ? (
                            <Dropdown
                              placeholder="Dashboards"
                              className="insights-accounts"
                              search
                              fluid
                              selection
                              value={selectedDashboard}
                              options={dashboardOptions}
                              onChange={this.onDashboardSelect}
                            />
                          ) : (
                            <span>{this.getDashboardName()}</span>
                          )}
                        </p>
                      </Grid.Column>
                      <Grid.Column width={2}>
                        <span className="insights-header-title">Accounts</span>
                        <div
                          className={
                            accounts.length > 7
                              ? 'insights-accounts-list-div'
                              : ''
                          }
                        >
                          <ul className="insights-account-list">
                            {accounts.map((account) => (
                              <li>{account}</li>
                            ))}
                          </ul>
                        </div>
                      </Grid.Column>
                      <Grid.Column width={2}>
                        <span className="insights-header-title">Date</span>
                        <p>{date}</p>
                      </Grid.Column>
                      {oem ? (
                        <Grid.Column width={2}>
                          <div>
                            <span className="insights-header-title">OEM</span>
                            <p>{oem}</p>
                          </div>
                        </Grid.Column>
                      ) : null}
                      {market.length > 0 ? (
                        <Grid.Column width={2}>
                          <span className="insights-header-title">Market</span>
                          <div
                            className={
                              market.length > 7
                                ? 'insights-accounts-list-div'
                                : ''
                            }
                          >
                            <ul className="insights-account-list">
                              {market.map((item) => (
                                <li>{item}</li>
                              ))}
                            </ul>
                          </div>
                        </Grid.Column>
                      ) : null}
                      {campaign ? (
                        <Grid.Column width={2}>
                          <span className="insights-header-title">
                            Campaign
                          </span>
                          <p>{campaign}</p>
                        </Grid.Column>
                      ) : null}
                      {funding ? (
                        <Grid.Column width={2}>
                          <span className="insights-header-title">Tier</span>
                          <p>{funding}</p>
                        </Grid.Column>
                      ) : null}
                    </Grid>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </div>
            <Divider hidden />
            <div>
              {showFilterTooltip ? (
                <div className="tooltip-container">
                  <div className="tooltip">
                    <div className="tooltiptext expand-all-step">
                      Filter the data using the <strong>Filters</strong>{' '}
                      dropdown below
                    </div>
                    <div
                      onMouseEnter={
                        showFilterTooltip ? this.toggleFilterTooltip : ''
                      }
                      className="tooltip-space"
                    >
                      {' '}
                    </div>
                  </div>
                </div>
              ) : null}
            </div>
            <iframe
              onLoad={this.toggleFilterTooltip}
              title="Looker Iframe"
              id="looker"
              className="insights-iframe-noborder"
              src={iframe}
            />
          </div>
        )}

        {showPasswordModal && (
          <IframePasswordModal
            loading={loadingIframe}
            showPasswordModal={showPasswordModal}
            togglePasswordModal={this.togglePasswordModal}
            getIframe={this.getIframe}
          />
        )}

        {!iframe && !loadingDashboards && !loadingIframe && (
          <div>
            <Message negative style={{ left: 0, bottom: 0 }}>
              <Message.Header>
                <Icon name="warning sign" /> Insights Preview could not be
                loaded
              </Message.Header>
              <p>{errorMessage || 'Something went wrong.'}</p>
            </Message>
          </div>
        )}
      </div>
    );
  }
}

export default InsightsPreviewDetails;



// WEBPACK FOOTER //
// ./src/screens/InsightsPreview/InsightsPreviewDetails.js